<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Analytics
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Compliance Report</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-triangle-exclamation me-1" style="color: #e6a100;"></i>
                  Extension keys that have not been accessed within the past 7 days.
               </small>
            </div>
         </div>
      </div>

      <ComplianceReport />
   </div>
</template>

<script>
import ComplianceReport from '@/components/Analytics/Compliance Report/ComplianceReport.vue';

export default {
   components: { ComplianceReport },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>